import { useSelector } from 'react-redux';

import { selectUserDomainCompanyImages } from '@/store/users/selectors';

import { Flex, Skeleton, Typography } from 'antd';

import MaterialButton from '../MaterialButton';

import useImage from '@shared/hooks/useImage';

import css from './RelatedMaterialCard.module.scss';

const { Title, Text } = Typography;

const SkeletonCard = () => (
  <Flex className={css['RelatedMaterialCard-skeleton']}>
    <Skeleton.Image active className={css['RelatedMaterialCard-skeleton-image']} />
    <Flex className={css['RelatedMaterialCard-skeleton-content']} align='center' gap={4}>
      <Skeleton active paragraph={{ rows: 1 }} />
    </Flex>
    <Skeleton.Button shape='circle' className={css['RelatedMaterialCard-skeleton-button']} active size='large' />
  </Flex>
);

const RelatedMaterialCard = ({ material }) => {
  const { corpCourseBackground } = useSelector(selectUserDomainCompanyImages);
  const image = corpCourseBackground ?? useImage(material?.thumbFileUuid, 'topic');

  // https://github.com/remix-run/react-router/issues/8245
  const handleRedirectToTopic = () => (window.location.href = `/collection-topics/${material?.id}`);

  return (
    <>
      <div className={css['RelatedMaterialCard']}>
        <img
          className={css['RelatedMaterialCard-image']}
          src={image}
          preview={false}
          onClick={handleRedirectToTopic}
          alt=''
        />
        <div className={css['RelatedMaterialCard-content']} onClick={handleRedirectToTopic}>
          <Text className={css['RelatedMaterialCard-content-type']}>{material?.type?.name}</Text>
          <Title
            className={css['RelatedMaterialCard-content-title']}
            level={3}
            ellipsis={{
              rows: 1,
              tooltip: material?.name,
            }}
          >
            {material?.name}
          </Title>
        </div>
        <div className={css['RelatedMaterialCard-button']}>
          <MaterialButton topic={material} mini inline buttonClassName={css['RelatedMaterialCard-button-comp']} />
        </div>
      </div>
    </>
  );
};

RelatedMaterialCard.Skeleton = SkeletonCard;

export default RelatedMaterialCard;
